import './home.css';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useCookies, Cookies } from 'react-cookie';
import { useLocation } from "react-router-dom";
import mileageGray from "./images/mileage-gray.svg";
import trash from "./images/trash.svg";

function Home(){
  const [registration, setRegistration] = useState('');
  const [cookies, setCookie, removeCookie] = useCookies();
  const navigate = useNavigate();
  const location = useLocation();

  return(
    <>
      <div className='hero'>
        <div className='hero-slogan'>
          <div>
            <h1>Check any car.</h1>
            <h1>Know where you stand.</h1>
          </div>
          <div>
            <p> Get an instant check on MOT status, vehicle history, recalls, and more.</p>
          </div>
        </div>
        <div className='reg-search-wrapper'>
          <input 
            className='reg-input' 
            placeholder='AB12 CDE'
            value={registration}
            onChange={e => setRegistration((e.target.value).toUpperCase())}
            minLength={1}
            maxLength={7}
            onKeyDown={(e) => {
              if (e.key === "Enter"){
                navigate(`/reg/${registration}`);
              }
            }}
          />
          {location.state?.message ? 
            <p>{location.state?.message}</p> : ""
          }
        </div>
      </div>
      <div>
        <div className='previous-searches-container'>
          <h2>Your recent checks</h2>
          <div className='previous-searches'>
        {Object.entries(cookies).map(([reg, cookie]) => (
          <div key={reg} className="previous-search-card">
            <img src={cookie.imageUrl} alt="" />
            <div className="previous-search-info">
              <a className="previous-search-reg" href={`/reg/${reg}`}>
                {reg}
              </a>
              <p>
                {cookie.make} {cookie.model} {cookie.manufactureDate}
              </p>
              <div style={{display: "grid", gridAutoFlow: "column", justifyContent:"start", gap: "8px"}}>
                <img src={mileageGray} 
                  alt="mileage image"
                  style={{height: "18px"}}/>
                <p>{cookie.mileage ? cookie.mileage : 0} miles</p>
              </div>
            </div>
            <img src={trash} 
              className='delete-btn'
              style={{height: "34px"}}
              onClick={() => removeCookie(reg, {path: "/"})}
            />
          </div>
        ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default Home;